// Logged-in app page: Clip packs (routes/ClipPacks.tsx). Keep keys in sync with en/appClipPacks.ts.
//
// Sesja 33 (język minimal): stan paczki jest JEDNĄ wartością — „do przeglądu” pigułką,
// „tnę” pigułką z jednym paskiem, „sprawdzona” SŁOWEM w linii liczb (reguła 5). Zdania,
// które wyleciały przez zasadę 8, są wypisane w `MAPA.md` sesji 33; nie wracają tu jako
// martwe klucze — zniknęły razem z miejscem, w którym stały.
export const appClipPacks = {
  head: {
    title: 'Paczki klipów',
    upload: 'Wgraj pliki',
  },
  // Stany paczek użytkownika. Paczki EDIMI noszą pigułkę „EDIMI”, nie stan.
  state: {
    reviewed: 'sprawdzona',
    cutting: 'tnę',
    needsReview: 'do przeglądu',
  },
  card: {
    // Rzeczownik po liczbie; sama liczba stoi mono obok (karta i linia stanu).
    clipsWord_one: 'klip',
    clipsWord_few: 'klipy',
    clipsWord_many: 'klipów',
    clipsWord: 'klipów',
    addFiles: 'Dodaj pliki',
    openAria: 'Otwórz paczkę „{name}”',
    // Paczka w cięciu ma JEDNĄ miarę postępu: pasek liczy pliki, linia ją nazywa.
    cuttingFiles_one: '{done} z {total} pliku',
    cuttingFiles_few: '{done} z {total} plików',
    cuttingFiles_many: '{done} z {total} plików',
    cuttingFiles: '{done} z {total} plików',
    deleteFailed: 'Nie udało się usunąć paczki.',
  },
  menu: {
    more: 'Więcej akcji: {name}',
    moveToCollection: 'Przenieś do kolekcji',
    merge: 'Scal z inną paczką',
    delete: 'Usuń paczkę',
  },
  delete: {
    ask: 'Usunąć paczkę „{name}”?',
    rowClips: 'Klipy',
    cancel: 'Anuluj',
  },
  sort: {
    label: 'Sortuj',
    newest: 'Najnowsze',
    oldest: 'Najstarsze',
    alpha: 'Alfabetycznie',
  },
  // Okno „Wgraj pliki” z kosztem PRZED startem (sesja 33, decyzja 7).
  upload: {
    nameLabel: 'Nazwa paczki',
    pick: 'Wybierz pliki',
    addMore: 'Dodaj więcej',
    removeFile: 'Usuń {name}',
    cost: 'Koszt',
    have: 'Masz',
    left: 'Zostanie',
    missing: 'Brakuje',
    // Jednostkę odmienia wspólny `tokenWord` (locales/plural.ts), nie własna
    // rodzina kluczy: przy dwóch kopiach jedno miejsce zawsze zostaje w tyle.
    cut: 'Potnij · {cost}',
    cutPlain: 'Potnij',
    cancel: 'Anuluj',
    busyTitle: 'Wgrywam pliki',
    files: 'Pliki {done} z {total}',
    abort: 'Przerwij',
    failedTitle: 'Nie udało się wgrać plików.',
    retry: 'Spróbuj ponownie',
    // Cena to jedyna liczba, której to okno nie zgaduje. Dopóki serwer jej nie
    // poda, cięcie jest zablokowane, a powód dociera do czytnika ekranu.
    priceLoading: 'Cennik jeszcze się nie wczytał - poczekaj albo odśwież.',
    priceRefresh: 'Odśwież cennik',
  },
  // Za mało tokenów (33-R3, artboard 03d): tabela liczb i JEDNA akcja. Zdanie
  // z odejmowaniem („Masz 3, potrzeba 30. Brakuje 27.”) wyleciało przez zasadę 8 —
  // wiersz „Brakuje” mówi to samo bez zdania.
  short: {
    title: 'Za mało tokenów',
    topUp: 'Doładuj tokeny',
  },
  toast: {
    uploaded: 'Pliki wgrane.',
    moved: 'Przeniesiono do kolekcji „{name}”.',
    movedNone: 'Paczka jest bez kolekcji.',
    moveFailed: 'Nie udało się przenieść paczki.',
    merged: 'Paczki scalone.',
    mergeFailed: 'Nie udało się scalić paczek.',
    deleted: 'Paczka usunięta.',
  },
  empty: {
    title: 'Brak paczek klipów',
    collectionTitle: 'Ta kolekcja jest pusta',
    showAll: 'Pokaż wszystkie paczki',
  },
  error: {
    title: 'Nie udało się wczytać paczek klipów.',
  },
  // Konto zawieszone (403): pigułka przy tytule ekranu i wygaszone akcje (reguła 18).
  denied: {
    actionOff: 'konto zawieszone',
  },
}
